import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/virtual.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import printIcon from '../images/printicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import disableIcon from '../images/disableicon.png';
import { data } from "react-router";
import CustomerDiv from "../common/customerdiv";

const MeetingInvoices=()=>
{
const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [invoicedata,setInvoiceData]=useState([]);
    const [times]=useState(["6:00","6:30","7:00","7:30","8:00","8:30","9:00","9:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00"]);
    const [dataToDisplay,setDataToDisplay]=useState([]);    
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({id:0,billno:"",billfor:"Meeting",cfacility :"",cname:"",ccompany:"",caddress:"",cstate:"",ccity:"",cmobile:"",cemail:"",cgstin:"",isgst:"",billdate:"",billfrom :"",billto :"",amount :0,cgstrate :9,igstrate :0,sgstrate :9,netamount :0,details:"",ispaid:"N",paymentdetails:"",isdeleted:"N",rate:0,starttime:"6:00",endtime:"6:00",meetingroom:""});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);
    const [meetingrooms,setMeetingRooms]=useState([]);
    const [gstshow,setGSTShow]=useState("none");
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Bill No", key: "billno", sortable: true},
        { name: "Facility", key: "cfacility", sortable: true },        
        { name: "Customer", key: "customer", sortable: false },        
        { name: "Details", key: "details", sortable: false },
        { name: "Bill Date", key: "billdate", sortable: true },
        { name: "Bill From", key: "billfrom", sortable: true},      
        { name: "Bill Upto", key: "billto", sortable: true},
        { name: "Amount", key: "amount", sortable: true},
        { name: "Tax Amount", key: "tax", sortable: false},
        { name: "Net Amount", key: "netamount", sortable: true },                
        { name: "Bill Paid", key: "ispaid", sortable: true },                
    ];
    function addInvoice(event)
    {
        setFormData({id:0,billno:"",billfor:"Meeting",cfacility :"",cname:"",ccompany:"",caddress:"",cstate:"",ccity:"",cmobile:"",cemail:"",cgstin:"",isgst:"N",billdate:"",billfrom :"",billto :"",amount :0,cgstrate :9,igstrate :0,sgstrate :9,netamount :0,details:"",ispaid:"N",paymentdetails:"",isdeleted:"N",rate:0,starttime:"6:00",endtime:"6:00",meetingroom:""});
        setGSTShow("none");
        setShow(true);
    }
    async function saveData(event)
    {
        setMsg("");          
        if(formData.cfacility.trim()=="none" || formData.cfacility.trim()=="")
        {
            setMsg("Select Facility!!!");
            return;
        }
        if(formData.billdate.trim()=="")
        {
            setMsg("Billing Date is Missing!!!");
            return;
        }
        if(formData.cname.trim()=="")
        {
            setMsg("Customer Details are Missing!!!");
            return;
        }
        if(formData.cmobile.trim().length!=10)
        {
            setMsg("Invalid Mobile No !!!");
            return;
        }        
       
        if(formData.billfrom.trim()=="")
        {
            setMsg("Billing From Date is Missing!!!");
            return;
        }        
        if(parseFloat(formData.amount)<=0)
        {
            setMsg("Billing Amount Missing/Incorrect!!!");
            return;
        }
        if(window.confirm('Are you sure?'))  
        {
            setProgress(true);
            let url="/api/Virtual/CreateMeetingInvoice";            
            if(formData.id!="") url="/api/Virtual/UpdateInvoice";
             //console.log("URL:"+url);            
             //console.log(JSON.stringify(formData));         
                await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadInvoiceData();
                        alert("Data Saved Successfully");
                        setFormData({id:0,billno:"",billfor:"Meeting",cfacility :"",cname:"",ccompany:"",caddress:"",cstate:"",ccity:"",cmobile:"",cemail:"",cgstin:"",isgst:"N",billdate:"",billfrom :"",billto :"",amount :0,cgstrate :9,igstrate :0,sgstrate :9,netamount :0,details:"",ispaid:"N",paymentdetails:"",isdeleted:"N",rate:0,starttime:"6:00",endtime:"6:00",meetingroom:""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });   
        }
        setProgress(false);
    }
    async function loadInvoiceData()
    {
        //console.log("Token:",localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Virtual/GetAllMeetingInvoices").then(res=>
        {
            if(res.status==200)
            {
                setInvoiceData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);                
            }
        });     
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=invoicedata.filter((e)=>e.ccompany.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.cname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.cfacility.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(invoicedata);                
                setPageData(invoicedata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="none")
            {
                let searchResult=invoicedata.filter((e)=>e.cfacility==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...invoicedata]);
                setPageData(invoicedata.slice(0,pageSize));
            }
            setPage(1);
        }         
    }
    async function formValueChanged(e)
    {
        const { id, value, type, checked } = e.target;
        if(id==="ispaid")
        {
            setFormData(prev => ({...prev,ispaid: checked ? "Y" : "N"}));
            return;
        }
        // GST checkbox handling
        if (id === "isgst") 
        {
            
            if(!isNaN(parseFloat(formData.amount)) && parseFloat(formData.amount)>0  && checked)
            {
                let amt=parseFloat(formData.amount);
                amt=Math.round(amt+ ((parseFloat(formData.cgstrate)+parseFloat(formData.sgstrate)+parseFloat(formData.igstrate))*amt/100));                
                setFormData(prev => ({...prev,isgst:"Y" ,netamount:amt}));                
            }
            else if(!isNaN(parseFloat(formData.amount)) && parseFloat(formData.amount)>0 && !checked)
            {
                let amt=parseFloat(formData.amount);
                setFormData(prev => ({...prev,isgst:"N",netamount:amt}));               
            }
            else
            {
                setFormData(prev => ({...prev,isgst:formData.isgst=="Y"?"N":"Y",netamount:0}));
            }
            setGSTShow(checked ? "block" : "none");
            return;
        }

        // Amount calculation
        if (id === "amount") 
        {
            if(formData.isgst=="Y")
            {
                let amt=parseFloat(value);
                amt=Math.round(amt+ ((parseFloat(formData.cgstrate)+parseFloat(formData.sgstrate)+parseFloat(formData.igstrate))*amt/100));
                setFormData(prev => ({...prev,amount:value,netamount:amt}));
            }
            else
            {
                let amt=value;
                setFormData(prev => ({...prev,amount:amt,netamount:amt}));
            } 
            return;
        }

        if (id === "cgstrate") 
        {
            if(formData.isgst=="Y")
            {
                let amt=parseFloat(formData.amount); 
                let gst=parseFloat(value);               
                amt=Math.round(amt+ ((gst+parseFloat(formData.sgstrate)+parseFloat(formData.igstrate))*amt/100));
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            }
            else
            {
                let amt=value;
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            } 
            return;
        }
        if (id === "sgstrate") 
        {
            if(formData.isgst=="Y")
            {
                let amt=parseFloat(formData.amount); 
                let gst=parseFloat(value);               
                amt=Math.round(amt+ ((gst+parseFloat(formData.cgstrate)+parseFloat(formData.igstrate))*amt/100));
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            }
            else
            {
                let amt=value;
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            } 
            return;
        }
        if (id === "igstrate") 
        {
            if(formData.isgst=="Y")
            {
                let amt=parseFloat(formData.amount); 
                let gst=parseFloat(value);               
                amt=Math.round(amt+ ((gst+parseFloat(formData.cgstrate)+parseFloat(formData.sgstrate))*amt/100));
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            }
            else
            {
                let amt=value;
                setFormData(prev => ({...prev,[id]:value,netamount:amt}));
            } 
            return;
        }
        if(id=="cfacility")
        {
            let facility=facilities.find(f=>f.facilityname.toLowerCase().trim()==value.toLowerCase().trim());
            setProgress(true);
            await apiClient.get(process.env.REACT_APP_APIURL+"/api/MeetingRoom/GetFacilityWiseMeetingRoom/"+facility.id).then(res=>
            {
                if(res.status==200 && res.data.status=="OK")
                {
                    setMeetingRooms(res.data.data);
                }
            });
            setProgress(false);
            setFormData(prev => ({...prev,[id]:value}));
            return;
        }
        if(id=="meetingroom" && value!="none")
        {
            var mr=meetingrooms.find((m)=>m.abbr==value);
            setFormData({...formData,rate:mr.amount,meetingroom:value});            
            return;
        }
        if(id=="meetingroom" && value=="none")
        {
            setFormData({...formData,rate:0,meetingroom:""});
            return;
        }
        if(id=="starttime")
        {
            let a1=calculateAmount(formData.rate,value,formData.endtime);      
            let a2=a1;
            if(formData.isgst=="Y") a2=a1+(a1*(parseFloat(formData.cgstrate)+parseFloat(formData.sgstrate)+parseFloat(formData.igstrate))/100)
            setFormData({...formData,starttime:value,amount:a1,netamount:a2});
            return;
        }
        if(id=="endtime")
        {
            let a1=calculateAmount(formData.rate,formData.starttime,value);
            let a2=a1;
            if(formData.isgst=="Y") a2=a1+(a1*(parseFloat(formData.cgstrate)+parseFloat(formData.sgstrate)+parseFloat(formData.igstrate))/100)
            setFormData({...formData,endtime:value,amount:a1,netamount:a2});
            return;
        }
        if(id=="billfrom")
        {
            setFormData({...formData,billfrom:value,billto:value});
            return;
        }
        // Default update
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    }
    function calculateAmount(rate,tstart,tend)
    {
        let s=parseFloat(tstart.replace(":",".").replace(".30",".5"));
        let e=parseFloat(tend.replace(":",".").replace(".30",".5"));
        return parseFloat(rate)*(e-s);
    }
    async function deleteInvoice(id)
    {
        
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            setProgress(true);
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/Virtual/DeleteInvoice/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadInvoiceData();                    
                }
            });
            setProgress(false);
        }
    } 
    function reverse(dt)
    {
        return dt.split("T")[0];
    }
    async function editInvoice(id)
    {
       let obj=invoicedata.find(i=>i.id==id);
       setGSTShow(obj.isgst=="Y"?"block":"none");
       setFormData({...obj,billdate:reverse(obj.billdate),billfrom:reverse(obj.billfrom),billto:reverse(obj.billfrom),isgst:obj.isgst.trim()});                                                
       setShow(true);                                
       
    }
    function sortData(colname)
    {
        if(colname=="cfacility" || colname=="ispaid" || colname=="billno")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="billdate" || colname=="billfrom" || colname=="billto")
        {
            let arr=[...invoicedata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="amount" || colname=="netamount")
        {
            let arr=[...invoicedata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadInvoiceData();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control form-control-sm" /></div>
                <div className="me-2">
                    <select className="form-control form-control-sm" id="searchFacility" onChange={searchData} style={{fontSize:'12px'}}>
                        <option value="none">Select Facility</option>
                        {facilities.map((e, idx) => <option key={`fac-${idx}`} value={e.facilityname}>{e.facilityname}</option>)}
                    </select>
                </div>                
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addInvoice} /></div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Meeting Room Invoices</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={i}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>Print</th>
                            <th>View/Edit</th>
                            <th>Delete</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={i}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                {                    
                                    if(ee.key=="customer")
                                        return(<td><CustomerDiv cname={e.cname} ccompany="" address={e.caddress+" "+e.cstate+" "+e.ccity} mobile={e.cmobile} cemail={e.cemail} /></td>);
                                    if(ee.key=="tax")
                                        return(<td>{e.netamount-e.amount}</td>);
                                    else
                                        return(<td>{(ee.key=="billdate" || ee.key=="billfrom" || ee.key=="billto")?e[ee.key].split("T")[0].split("-").reverse().join("-"):e[ee.key]}</td>);                                                                
                                }
                                )}
                                <td className="text-center"><img onClick={()=>{window.open(process.env.REACT_APP_APIURL+"/api/Virtual/PrintMeetingInvoice/"+e.id,"","width=700,height=900")}} src={printIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>editInvoice(e.id)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>deleteInvoice(e.id)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="3"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="11" className="text-center"></th>
                            <th colSpan="1" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="15">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray',overflow:"auto"}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Meeting Room Invoice</div>
                                        <div className="row">
                                            <div><input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control form-control-sm d-none"/></div>
                                            <div className="col-12 fw-bold">Bill No: {formData.billno}</div>
                                            <div className="col-4">
                                                <select id="cfacility" onChange={formValueChanged} value={formData.cfacility} className="form-control form-control-sm ">
                                                    <option value="none">Select Facility</option>
                                                    {facilities.map((e, idx) => <option key={`fac-${idx}`} value={e.facilityname} selected={formData.cfacility==e.facilityname}>{e.facilityname}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-4">                                                
                                                <select onChange={formValueChanged} id="meetingroom" value={formData.meetingroom} className="form-control form-control-sm">
                                                    <option value="none">Select Meeting Room</option>    
                                                    {meetingrooms.map((e,i)=>
                                                        <option key={i} value={e.abbr}>{e.abbr+" - "+e.name}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col-4"><input type="date" id="billdate" onChange={formValueChanged} value={formData.billdate} className="form-control form-control-sm"  /></div>                                                                                                                           
                                            <div className="col-12 mt-1"><input type="text" id="cname" value={formData.cname} onChange={formValueChanged} className="form-control form-control-sm" placeholder="Name...." /></div>
                                            <div className="col-12 mt-1"><input type="text" id="ccompany" value={formData.ccompany} onChange={formValueChanged} className="form-control form-control-sm" placeholder="Company..." /></div>
                                            <div className="col-12 mt-1 mb-1"><input type="text" id="caddress" onChange={formValueChanged} value={formData.caddress} className="form-control form-control-sm" placeholder="Address" /></div>                                    
                                            <div className="col-4"><input type="text" id="cstate" onChange={formValueChanged} value={formData.cstate} className="form-control form-control-sm" placeholder="State" /></div>
                                            <div className="col-4"><input type="text" id="ccity" onChange={formValueChanged} value={formData.ccity} className="form-control form-control-sm" placeholder="City" /></div>
                                            <div className="col-4"><input type="number" id="cmobile" onChange={formValueChanged} value={formData.cmobile} className="form-control form-control-sm" placeholder="Mobile No" /></div>
                                            <div className="col-6 mt-1 mb-1"><input type="email" id="cemail" onChange={formValueChanged} value={formData.cemail} className="form-control form-control-sm" placeholder="Email" /></div>
                                            <div className="col-6 mt-1 mb-1"><input type="text" id="cgstin" onChange={formValueChanged} value={formData.cgstin} className="form-control form-control-sm" placeholder="GSTIN" /></div>
                                            <div className="col-12"><input type="checkbox" id="isgst" onChange={formValueChanged} checked={formData.isgst=="Y"}  /> GST Billing</div>                                            
                                            <div className="col-12 p-2" style={{overflow:"auto",fontSize:'12px'}}>
                                                <table className="table" cellPadding="0" cellSpacing="0">
                                                    <tbody>
                                                        <tr><td style={{width:'33%'}}>Booking Date</td><td  style={{width:'33%'}}>From</td><td  style={{width:'33%'}}>Upto</td></tr>
                                                        <tr>
                                                            <td><input type="date" id="billfrom" value={formData.billfrom} onChange={formValueChanged} className="form-control form-control-sm " /></td>
                                                            <td>
                                                                <select id="starttime" onChange={formValueChanged} value={formData.starttime}  className="form-control form-control-sm" >
                                                                    {times.map((e,i)=><option key={i} value={e}>{e}</option>)}
                                                                </select>                                                                
                                                            </td>
                                                            <td>
                                                                <select  id="endtime" onChange={formValueChanged} value={formData.endtime}  className="form-control form-control-sm" >
                                                                    {times.map((e,i)=><option key={i} value={e}>{e}</option>)}
                                                                </select>                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Rate/Hour: <b>{formData.rate}</b></td>
                                                            <td>Amount</td>
                                                            <td><input type="text" onChange={formValueChanged} id="amount" value={formData.amount} className="form-control form-control-sm" /></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Billing Details</td>
                                                            <td><span style={{display:gstshow}}>CGST Rate %</span></td>
                                                            <td><input type="number" id="cgstrate" style={{display:gstshow}} value={formData.cgstrate} onChange={formValueChanged} className="form-control form-control-sm " /></td>
                                                        </tr>
                                                        <tr>                                                            
                                                            <td rowSpan="3">
                                                                <textarea id="details" rows="5" onChange={formValueChanged} value={formData.details}></textarea>
                                                            </td>
                                                            <td ><span style={{display:gstshow}}>SGST Rate %</span></td><td><input type="number" id="sgstrate" value={formData.sgstrate} style={{display:gstshow}} onChange={formValueChanged} className="form-control form-control-sm " /></td></tr>
                                                        <tr><td ><span style={{display:gstshow}}>IGST Rate %</span></td><td><input type="number" id="igstrate" value={formData.igstrate} style={{display:gstshow}} onChange={formValueChanged} className="form-control form-control-sm " /></td></tr>
                                                        <tr><td>Net Amount</td><td><input type="number" id="netamount" value={formData.netamount} onChange={formValueChanged} className="form-control form-control-sm " readOnly /></td></tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-12 p-2" style={{backgroundColor:"#f0b4c2ff",marginTop:-20}}>
                                                <input type="checkbox" id="ispaid" onChange={formValueChanged} checked={formData.ispaid=="Y"} /> Invoice Paid<br/>
                                                Payment Details:<br/>
                                                <input type="text" id="paymentdetails" value={formData.paymentdetails} onChange={formValueChanged} className="form-control form-control-sm" />
                                            </div>
                                        </div>
                                    <input type="button" className="btn btn-sm btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default MeetingInvoices;